import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import { errorMsg } from '../SnackbarUtilsConfigurator';
import { CreateNewDialog } from '@terragotech/gen5-shared-components';
import { TextInputTG, TGIosSwitch, TGSelect } from 'views/components/formElements';
interface Props {
  onSubmit: (result: { label: string; value: string; isLink?: boolean }) => void;
  onClose: () => void;
  selectOptions: string[];
  initialLabel?: string;
  initialSelect?: string;
  initialLink?: boolean;
}

export const SelectModal: React.FC<Props> = ({
  onSubmit,
  onClose,
  selectOptions,
  initialLabel,
  initialSelect,
  initialLink,
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [label, setLabel] = useState<string | undefined>(initialLabel);
  const [value, setValue] = useState<string | undefined>(initialSelect);
  const [isLink, setLink] = useState<boolean>(!!initialLink);

  const handleOnSubmit = () => {
    if (!label) return errorMsg('Label is required');
    if (!value) return errorMsg('Select Value is required');
    onSubmit({ label, value, isLink });
  };

  return (
    <CreateNewDialog
      submitText="Done"
      title={'Select Value'}
      onClose={onClose}
      onSubmit={handleOnSubmit}
    >
      <TextInputTG
        id="label"
        label="Label"
        value={label}
        onChange={(value) => setLabel(value)}
        labelRoot={classes.label}
        style={{ marginBottom: 10 }}
      />
      <TGSelect
        id="value"
        label="Value"
        value={value || ''}
        onChange={(value) => setValue(value)}
        options={selectOptions}
        style={{ marginBottom: 10 }}
      />
      <TGIosSwitch
        title="Is Link?"
        checked={isLink}
        onChange={(value) => setLink(value)}
        description={'Selecting this will link to the record that the selected value came from'}
      />
    </CreateNewDialog>
  );
};

const useStyles = makeStyles({
  label: (props: { theme: any }) => ({
    fontSize: '15px !important',
    fontWeight: 500,
    lineHeight: '100%',
    color: props.theme.palette.text.primary,
  }),
});
